/* `/marketplace/listings/{agent_id}` — how a workspace's agent shows in the consumer app's
   marketplace. The wire, as the API answers it (snake_case): backend/modules/marketplace/README.md. */

/** The marketplace sidebar's categories, in its order. */
export const MARKETPLACE_CATEGORIES = ["everyday", "work", "money", "travel", "health", "learning"] as const;
export type MarketplaceCategory = (typeof MARKETPLACE_CATEGORIES)[number];

/** The backend's `TAGLINE_CHARS`. */
export const TAGLINE_MAX = 80;

export interface MarketplaceListing {
  agent_id: string;
  /** Null: no category — the agent shows only under All and in search. */
  category: MarketplaceCategory | null;
  /** One line under its name on its card. */
  tagline: string | null;
  /** Definable put it on the featured shelf. */
  featured: boolean;
  /** Definable took it out of the marketplace; its link and channels still work. */
  hidden: boolean;
  /** Null until it is first saved. */
  updated_at: string | null;
}

/** Both replace what was there; null clears one. */
export interface MarketplaceListingSave {
  category: MarketplaceCategory | null;
  tagline: string | null;
}
